import { BrowserRouter, Route, Routes } from 'react-router'
import { SignIn } from '../screens/signin/SignIn.js'
import { AcceptInvite } from '../screens/signin/AcceptInvite.js'
import { ResetPassword } from '../screens/signin/ResetPassword.js'

/**
 * The two links a person can follow without a session — an invite and a
 * password reset — plus Sign in for everything else. Once signed in, App.tsx
 * swaps this for the real router, whose catch-all sends any leftover
 * /accept-invite or /reset-password path to Home.
 */
export function SignedOutRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/accept-invite" element={<AcceptInvite />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="*" element={<SignIn />} />
      </Routes>
    </BrowserRouter>
  )
}
